const ar = {
  navbar: {
    about: "من نحن ؟",
    content: "المحتويات التعليمية",
    features: "مميزات التطبيق",
    trust: "وثقوا بنا",
    contact: "تواصل معنا",
    parent: "فضاء الولي",
  },

  header: {
    lines: [
      "تطبيق خُطوة هو الرّفيق المثاليّ لأطفال المرحلة الابتدائيّة الّذين",
      "يرغبون في تعزيز تجربتهم التّعليميّة بطريقة ممتعة ومشوّقة.",
      "تطبيق أُعدّ من قبل خبراء بيداغوجيين في ضوء البرامج المدرسيّة",
      "وأفضل الطّرق والمداخل التربويّة المعاصرة.",
    ],
    download: "حمّل التطبيق الان",
  },
  about: {
  title:"من نحن ؟",
  lines: [
    "خطوة هو تطبيق تعليمي ثوري يعيد تصور التعلم الابتدائي للأطفال من سن 5 إلى 12 عامًا.",
    "من خلال دمج الواقع المعزز والذكاء الاصطناعي، فإنه يقدم تجربة غامرة وتفاعلية فريدة من نوعها.",
    "سيناريوهات مليئة باللعب ثنائي الأبعاد / ثلاثي الأبعاد صُمِّم لتحفيز المهارات المعرفية بطريقة مسلية وإبداعية وتعزيز التعلم الشخصي.",
  ],
  },

  educational: {
    title: 'المحتويات التعليميّة',
    items: [
      'ألعاب تعليمية',
      'واقع معزز',
      'مخبر علوم',
      'مهارات حياتية',
      'فنون المحادثة',
      'فيديوهات وقصص مفيدة',
    ],
  },

  features: {
    sectionTitle: {
      first: 'مميزات',
      second: 'التطبيق',
    },
    steps: [
      'محتوى متوافق مع المناهج الدراسية',
      'تجاوز الصعوبات',
      'الواقع المعزز',
      'هرم بلوم للأهداف التعليمية',
      'ما يقدمه تطبيق خطوة للوالدين',
    ],
    heading:'محتوى متوافق مع المناهج الدراسيّة',
    paragraphs: [
      'في تطبيق "خُطوة"، نحرص على تطابق جميع الموادّ الدراسيّة المُقدّمة مع',
      'البرامج الرسميّة للمرحلة الابتدائية وحين تتعدّاها فمن أجل إسنادها ',
      'وإغنائها والتوسّع في مضامينها.',
      'فريقنا البيداغوجي المحترف والتدقيق المتعدّد المستويات ضمانتا الإعداد',
      'الجيّد للأنشطة التعليميّة والألعاب التربويّة التي تستند إلى المناهج ',
      'والمقاربات الرسميّة'
    ],
  },
  teacher: {
    title: "وثقوا بنا",
    subtitle: "المعلّمون والمعلّمات",
    downloadTitleAlt: "صورة عنوان وثقوا بنا",
    testimonials: [
      {
        name: "آية النّوي",
        title: "أستاذة المدارس الابتدائية",
        comment:
          "المتعة والتعلم في رحلة فريدة لاستكشاف العالم بطريقة مشوقة ومسلية. هذا هو تطبيق خطوة، المبتكر التونسي الذي يجمع بين الألعاب والتعلم في آن واحد... لتعزيز المفاهيم التعليمية مع تقييم فردي وتقارير تطويرية هنيئا لكم.",
      },
      {
        name: "نجم الدين جرفال",
        title: "أستاذ مدارس ابتدائيّة فوق الرّتبة مميّز متقاعد",
        comment:
          "هي خطوة ثابتة للارتقاء بالمتعلم نحو التميّز وبناء معارفه على أسس صلبة والسموّ به نحو الأفضل والتعلم في جو من الاستمتاع اعتمادا على ما يقدّم له من تمارين تهدف إلى تجويد مكتسباته بطريقة رائعة تقوده إلى التفوّق.",
      },
      {
        name: "حبيبة الرايس",
        title: "مدرّسة العربيّة للمبتدئين",
        comment:
          "في زمن التكنولوجيا خطوتان ضروريتان، خطوة للمعرفة وخطوة للتكنولوجيا وذاك تطبيق خطوة.",
      },
      {
        name: "محمد زيراوي",
        title: "مدرسة المعرفة للمدنيين",
        comment:
          "هي بمثابة كبسولات تربوية تعليمية حديثة ومبتكرة متطابقة مع البرامج الرسمية و تمس الذكاءات المميزة لكل متعلم وأنماط تعلمه. فهي تعالج الصعوبات و تنمي المهارات والقدرات للتلميذ مع سهولة في الاستعمال",
      },
      {
        name: "سالمة الحبيبي",
        title: "أستاذ أول فوق الرتبة للمدارس الابتدائية",
        comment: "لكل بداية خطوة أولى. و تطبيق خطوة سيكون الخطوة الأولى نحو التميّز .",
      },
    ],
    images: {
      topCloudsAlt: "غيوم في الأعلى",
      bottomDecorAlt: "ديكور الغيوم في الأسفل",
      lampeAlt: "صورة المصباح",
      staraloneAlt: "زينة نجم",
      notebookAlt: "زينة دفتر",
      astroAlt: "زينة رائد فضاء",
    },
  },

  contact: {
    sectionTitle: { first: 'تواصل', second: 'معنا' },
    cards: [
      { title: 'خدمة الحرفاء',  line: '078 078 56 216+' },
      { title: 'البريد الالكتروني', line: 'contact@khotoua.com' },
      { title: 'مواقع التواصل الاجتماعي' },
    ],
    socialsAlt: {
      tiktok: 'تيك توك',
      facebook: 'فيسبوك',
      instagram: 'إنستغرام',
      linkedin: 'لينكدإن',
      youtube: 'يوتيوب',
    },
  },

  download: {
    titleAlt   : 'حمل التطبيق الآن',
    titleText  : 'حمل التطبيق الآن',
    description: 'وفر لطفلك الرّفيق المثاليّ لتعزيز\nتجربته التّعليميّة بطريقة ممتعة ومشوّقة',
    cta        : 'حمّل التطبيق الآن',
  },

  footer: {
    title: 'لكل إنجاز خطوة...',
    sectionsCol1: [
      { id: 'about', label: 'من نحن ؟' },
      { id: 'content', label: 'المحتويات التعليمية' },
      { id: 'features', label: 'السياسة العامة' },
    ],
    sectionsCol2: [
      { id: 'trust', label: 'وثقوا بنا' },
      { id: 'download', label: 'مميزات التطبيق' },
      { id: 'contact', label: 'تواصل معنا' },
    ],
    logoAlt: 'لوغو خطوة',
    orangeLineAlt: 'خط برتقالي',
    productBy: 'المنتج المنفذ :',
  },

  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث:',
    introduction: 'في تطبيق خُطوة، نحن ملتزمون بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وكشف وحماية معلوماتك عند استخدام تطبيقنا.',
    sections: [
      {
        title: 'المعلومات التي نجمعها',
        content: 'نجمع المعلومات التي تقدمها لنا مباشرة، بما في ذلك: اسم ومعلومات الملف الشخصي (مثل صورة الملف الشخصي)، ومعلومات الجهاز (مثل معرف الجهاز ونظام التشغيل والشبكة المحمولة)، وبيانات الاستخدام (مثل الميزات المستخدمة والوقت المستغرق في التطبيق)، وبيانات التشخيص (مثل سجلات الأعطال وبيانات الأداء).',
      },
      {
        title: 'كيف نستخدم معلوماتك',
        content: 'نستخدم المعلومات التي نجمعها لـ: تقديم وتحسين خدماتنا، تخصيص تجربتك، التواصل معك بشأن التحديثات والميزات الجديدة، تحليل أنماط الاستخدام لتعزيز أداء التطبيق، وضمان الأمان ومنع الاحتيال.',
      },
      {
        title: 'مشاركة البيانات والإفصاح عنها',
        content: 'لا نبيع معلوماتك الشخصية. قد نشارك المعلومات مع: مزودي الخدمة الذين يساعدوننا في تشغيل التطبيق، وشركاء التحليلات لمساعدتنا في فهم استخدام التطبيق، والسلطات القانونية عند الضرورة.',
      },
      {
        title: 'أمان البيانات',
        content: 'نقوم بتنفيذ التدابير التقنية والتنظيمية المناسبة لحماية معلوماتك الشخصية ضد الوصول غير المصرح به أو التعديل أو الإفصاح أو الإتلاف.',
      },
      {
        title: 'خصوصية الأطفال',
        content: 'تم تصميم تطبيقنا للأطفال من سن 5 إلى 12 عامًا. نجمع الحد الأدنى من المعلومات الشخصية من الأطفال، بموافقة الوالدين. يمكن للوالدين مراجعة أو تحديث أو حذف معلومات طفلهم في أي وقت.',
      },
      {
        title: 'حقوقك',
        content: 'لديك الحق في: الوصول إلى معلوماتك الشخصية، طلب تصحيح البيانات غير الدقيقة، طلب حذف بياناتك، الاعتراض على معالجة بياناتك، وتصدير بياناتك بتنسيق محمول.',
      },
      {
        title: 'حذف الحساب',
        content: 'لطلب حذف حسابك وبياناتك الشخصية، يرجى إرسال بريد إلكتروني إلى contact@khotoua.com مع عنوان بريدك الإلكتروني للحساب. سنعالج طلبك خلال 30 يومًا.',
      },
      {
        title: 'التغييرات على هذه السياسة',
        content: 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات جوهرية من خلال نشر السياسة الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث".',
      },
      {
        title: 'تواصل معنا',
        content: 'إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا على contact@khotoua.com.',
      },
    ],
  },

};

export default ar;
